import React from 'react';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import { getSession, setSession, getCookie, isMoversPhase2, isMoversFlow, isCurrentPlanVHILite, isVHILiteQualified, isVHILiteAllplansIncludeFFlag, isVHILiteFlow, istgwAllPlansIncludeFFlag} from './Helpers';
import { updateEventInfo, eventDispatcher } from './Tagging/index';
import { FED_DISCOUNT_MAPPING } from '../../pages/CBandPlans/Constants';
import { getPlanReferenceData } from '../../utils/plansReference';

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 3rem;
  height: 3rem;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  z-index: 1;
`;

export const getNetworkBandWidthIndicator = () => {
  const networkValue = getCookie('moversNetworkBandwidth');
  const cookieValue = {
    previousBandWidth: networkValue?.split('_')?.[0] || networkValue,
    currentBandWidth: networkValue?.split('_')?.[1] || networkValue,
  };

  const previousBandWidth = getSession('networkBandwidthType') || cookieValue?.previousBandWidth;
  const currentBandWidth = JSON.parse(getSession('LQResponse'))?.output?.networkBandwidthType || cookieValue?.currentBandWidth;
  return { previousBandWidth: previousBandWidth?.toUpperCase(), currentBandWidth: currentBandWidth?.toUpperCase() };
};

export const isLiketoLikeFlow = () => {
  const networkBandWidth = getNetworkBandWidthIndicator();
  const isCrossPlan = () => {
    const isVHILitePlan = isCurrentPlanVHILite();
    const isVHILiteQualifiedForMove = isVHILiteQualified();
    const isLike = networkBandWidth?.previousBandWidth?.toUpperCase() === networkBandWidth?.currentBandWidth?.toUpperCase();
    if (isLike && networkBandWidth?.currentBandWidth.toUpperCase() === 'LTE') {
      return ((!isVHILitePlan && isVHILiteQualifiedForMove) || (isVHILitePlan && !isVHILiteQualifiedForMove));
    }
    return !(isLike && networkBandWidth?.currentBandWidth.toUpperCase() !== 'LTE');
  };
  if (networkBandWidth?.previousBandWidth !== undefined && networkBandWidth?.previousBandWidth !== null && networkBandWidth?.currentBandWidth !== undefined && networkBandWidth?.currentBandWidth !== null) {
    if (!isCrossPlan()) {
      return true;
    }
  }
  return false;
};

export const isLTEMoveIn = () => {
  const networkBandWidth = getNetworkBandWidthIndicator();
  if (networkBandWidth?.currentBandWidth !== undefined && networkBandWidth?.currentBandWidth !== null) {
    if (networkBandWidth?.currentBandWidth?.toUpperCase() === 'LTE') {
      return true;
    }
  }
  return false;
};

export const NotificationCondition = (props) => {
  let notificationProps = {
    renderIf: false,
    title: '',
    type: 'warning',
  };

  //  Error will shown at compare plan api failure
  if (props?.comparePlanDetails?.errorInfo?.status === true) {
    notificationProps = {
      renderIf: props?.comparePlanDetails?.errorInfo?.status,
      title: 'Looks like something went wrong. Please try again later',
      type: 'warning',
    };
  } else if (props.getAvailablePlansErrorMessage) {
    notificationProps = {
      renderIf: props?.getAvailablePlansErrorMessage,
      title: 'Looks like something went wrong. Please try again later',
      type: 'warning',
    };
  } else if (props?.getUpdateCustomerPlanErrorMessage) {
    notificationProps = {
      renderIf: props?.getUpdateCustomerPlanErrorMessage,
      title: 'Looks like something went wrong. Please try again later',
      type: 'warning',
    };
  } else if (props?.getFccLabelDetailsErrorMessage?.errorValue === true) {
    notificationProps = {
      renderIf: props?.getFccLabelDetailsErrorMessage?.errorValue,
      title: 'Looks like something went wrong. Please try again later',
      type: 'warning',
    };
  } else {
    notificationProps = {
      renderIf: false,
      title: '',
      type: '',
    };
  }
  return notificationProps;
};

export const parseMobileNumber = (number) => {
  let parsedNumber = null;
  if (number) {
    parsedNumber = `${number?.slice(0, 3)}.${number?.slice(3, 6)}.${number?.slice(6, 10)}`;
    return parsedNumber;
  }
  return parsedNumber;
};

export const isLegacyPlanFunc = (willowJsonArray, currentPlan) => {
  if (willowJsonArray?.includes(currentPlan)) return false;
  return true;
};

export const hideAllVisibleModals = () => {
  const openedModal = document.querySelectorAll('[class^=ModalContainer]');
  if (openedModal.length > 0) {
    for (let i = 0; i < openedModal.length; i++) {
      openedModal[i].hidden = true;
    }
  }
};

export const onBroadBandInfoClick = (isMVA, mvaLinkApiCall, apiUrls) => {
  if (isMVA()) {
    mvaLinkApiCall(apiUrls().mfAppBroadBandUrl);
  } else {
    window.open(apiUrls().broadBandUrl, '_blank');
  }
};

export const storePlanDataAfterDiscounts = (props, planId, selectedPlanData, fetchMHDiscounts) => {
  const { UNLIMITED, AUTOPAY, MHPREMIUM } = FED_DISCOUNT_MAPPING;
  const appliedDiscounts = [
    ...(selectedPlanData.autoPayDiscountPrice ? [AUTOPAY] : []),
    ...(selectedPlanData.unlimitedPlanDiscountPrice ? [UNLIMITED] : []),
    fetchMHDiscounts(planId) === 'MHPremium' ? MHPREMIUM : '',
  ];
  if (getSession('isPlansEdit') !== 'Y') {
    updateEventInfo('scOpen');
  }
  if (selectedPlanData?.employeeDiscount !== null) {
    setSession('isEmployeeDiscount', 'Y');
  } else {
    setSession('isEmployeeDiscount', 'N');
  }
  const bundleId = '';
  const bundleName = props?.plansReferenceData?.[bundleId];
  const planData = {
    planId,
    appliedDiscounts,
  };
  let sfoData = props.updateSfoData;
  if (sfoData && sfoData.length === 0) {
    if (bundleId) {
      sfoData.push({
        id: bundleId,
        bundlename: bundleName,
        actionindicator: 'A',
      });
    }
  } else if (sfoData && sfoData.length > 0) {
    sfoData = sfoData.filter((each) => each.actionindicator === 'A' && each.id !== bundleId);
    if (sfoData && sfoData.length > 0) {
      if (sfoData[0]?.actionindicator) {
        sfoData[0].actionindicator = 'D';
      }
      if (bundleId) {
        sfoData.push({
          id: bundleId,
          bundlename: bundleName,
          actionindicator: 'A',
        });
      }
    } else {
      sfoData = props.updateSfoData;
    }
  }
  if (sfoData && sfoData.length > 0) {
    props.updateCurrentSfo(sfoData);
  }
  setSession('selectedPlanData', JSON.stringify(planData));
  planData.sfo = sfoData;
};

export const itemsAutopay = (overviewData, isEmp, employeeDiscount, autopayDiscount) => [
  {
    title: {
      children: parse(overviewData?.AllPlanText || ''),
    },
    ...(isEmp && { text: { children: `${employeeDiscount}% off`, id: `Employee Discount All plans ${employeeDiscount}% off` } }),
    ...(!isEmp && { amount: { price: `-$${autopayDiscount}`, id: `Auto Pay Discount All plans ${autopayDiscount}` } }),
  },
  {
    title: {
      children: isEmp ? overviewData?.EmployeeDiscountSubTitle : overviewData?.AutopayDiscountSubTitle,
    },
  },
];

export const planDiscountsTagging = ({ onlyMHDiscount = false, isstreamlineMinicartNSEFFlag = false, showDiscountsModal }) => { 
  const taggingValue = { type: 'link', name: '', data: {page: {detail: ''}}};
  if(isstreamlineMinicartNSEFFlag && showDiscountsModal) { 
    taggingValue.name = 'close plan discounts modal';
    taggingValue.data.page.detail = 'plan discounts modal';
  }else if(!isstreamlineMinicartNSEFFlag && onlyMHDiscount) {
    taggingValue.name = 'close';
    taggingValue.data.page.detail = 'partial plan discount modal';
  }else if(showDiscountsModal) {
    taggingValue.name = 'close';
    taggingValue.data.page.detail = 'full plan discount modal';
  }
  return JSON.stringify(taggingValue);
};
export const openViewTagging = ({ onlyMHDiscount = false, isstreamlineMinicartNSEFFlag = false }) => {
  if(isstreamlineMinicartNSEFFlag && onlyMHDiscount) { 
    eventDispatcher('openView', {
      name: 'plan discounts modal open',
    });
  } else if (onlyMHDiscount) {
    eventDispatcher('openView', {
      name: 'partial plan discount modal',
    });
  } else {
    eventDispatcher('openView', {
      name: 'full plan discount modal',
    });
  }
};

export const handleModalOpenedChange = ({ e, emberDiscountModalFFlag, onlyMHDiscount, isstreamlineMinicartNSEFFlag, setShowDiscountsModal }) => {
  if (emberDiscountModalFFlag) {
    if (e) { 
      openViewTagging({onlyMHDiscount, isstreamlineMinicartNSEFFlag}) 
    } else {
      setShowDiscountsModal(null)
    }
  } else if (e) { 
    openViewTagging({onlyMHDiscount, isstreamlineMinicartNSEFFlag}) 
  }
};
export const discountArgs = (data) =>  {
  const { overviewData,
  availablePromotions,
  discountItems,
  isEmp,
  employeeDiscount,
  autopayDiscount,
  closeExtrasModal,
  showDiscountsModal,
  setShowDiscountsModal,
  onlyMHDiscount = false,
  isstreamlineMinicartNSEFFlag = false,
  emberDiscountModalFFlag = false } = data;
  const discountsTitle = (itemData) => {
    switch(itemData) {
      case 'MHDiscount':
        return parse(overviewData?.MHDiscountTitle || '');
      case 'Autopay':
        return parse(overviewData?.AutopayDiscountTitle || '');
      case 'Employee':
        return parse(overviewData?.EmployeeDiscountTitle || '');
      default:
        return '';
    }
  };
  const discountChildren = (itemData) => {
   let childrenData = '';
   if (itemData === 'MHDiscount') {
    childrenData = discountItems;
   } else if(itemData === 'Autopay' || itemData === 'Employee') {
     childrenData = itemsAutopay(overviewData, isEmp, employeeDiscount, autopayDiscount);
   }
   return childrenData;
  }
  const discountData =  {
  title: {
    primitive: 'h4',
    children: parse(overviewData?.discountOverlayHead || ''),
  },
  subtitle: {
    children: parse(overviewData?.discountOverlaySubHead || ''),
  },
  discounts: availablePromotions.map((item) => ({
    title: {
      children: discountsTitle(item),
    },
    items: discountChildren(item),
  })),
  buttonData: {
    primary: {
      children: 'Close',
      'data-track': planDiscountsTagging({onlyMHDiscount, isstreamlineMinicartNSEFFlag, showDiscountsModal}),
      onClick: () => {
        closeExtrasModal();
        setShowDiscountsModal(false);
      },
    },
  },
  opened: showDiscountsModal,
  onOpenedChange: (e) => {
    handleModalOpenedChange({ 
      e, 
      emberDiscountModalFFlag, 
      onlyMHDiscount, 
      isstreamlineMinicartNSEFFlag, 
      setShowDiscountsModal, 
    });
  },
  closeButton: (
          <CloseButtonWrapper>
            <ButtonIcon
              role='button'
              data-testid='plandiscountmodal-close'
              data-track={planDiscountsTagging({onlyMHDiscount, isstreamlineMinicartNSEFFlag, showDiscountsModal})}
              onClick={() => {
                 setShowDiscountsModal(false);
              }}
              kind='ghost'
              size='small'
              renderIcon={(iconprops) => <Icon name='close' {...iconprops} />}
            />
          </CloseButtonWrapper>
  ),
}
return discountData;
};

export const promotionConstants = {
  MHBasic: 'MHBasic',
  Autopay: 'Autopay',
  MHPremium: 'MHPremium',
};

export const getToolTipContent = (discounts, eligibleDiscount, featureData) => {
  let tooltipContent = '';
  // if disc is not there, show lowPriceTooltip
  if (!eligibleDiscount || (eligibleDiscount && eligibleDiscount?.length === 0)) {
    tooltipContent = featureData?.lowPriceTooltip;
  }

  // if only autopay id there, showing premium disc only
  else if (discounts?.[promotionConstants.Autopay] && !discounts?.[promotionConstants.MHPremium] && !discounts?.[promotionConstants.MHBasic]) {
    tooltipContent = `${featureData?.toolTipHeading}${featureData?.mhTooltip}`;
  }

  // if only premium disc is there, showing autopay only
  else if (!discounts?.[promotionConstants.Autopay] && !discounts?.[promotionConstants.MHBasic] && discounts?.[promotionConstants.MHPremium]) {
    tooltipContent = `${featureData?.toolTipHeading}${featureData?.autopayTooltip}`;
  }

  // if only basic plan is there showing autopay and nonPremium disc
  else if (!discounts?.[promotionConstants.Autopay] && discounts?.[promotionConstants.MHBasic] && !discounts?.[promotionConstants.MHPremium]) {
    tooltipContent = `${featureData?.toolTipHeading}${featureData?.mhNonPremiumTooltip}<br><br>${featureData?.autopayTooltip}`;
  }

  // if autopay and basic is there, show nonPremium disc
  else if (discounts?.[promotionConstants.Autopay] && discounts?.[promotionConstants.MHBasic] && !discounts?.[promotionConstants.MHPremium]) {
    tooltipContent = `${featureData?.toolTipHeading}${featureData?.mhNonPremiumTooltip}`;
  }
  return tooltipContent;
};

export const getExtrasContent = (promoData, userType, promoListCommon, promoList) => [
  {
    items: promoListCommon,
  },
  {
    title: {
      children: promoData?.[`extraChoiceHeader_${userType}`] !== '-NA-' && promoData?.[`extraChoiceHeader_${userType}`],
    },
    helperText: {
      children: promoData?.[`extrasChoiceFooter_${userType}`] !== '-NA-' && promoData?.[`extrasChoiceFooter_${userType}`],
    },
    items: promoList,
  },
];

export const getExtrasTitle = (promoData, userType) => promoData?.[`extrasCommonDesc_${userType}`] !== '-NA-' && promoData?.[`extrasCommonDesc_${userType}`];

export const checkIsEPCFlow = () => {
  const { isEPC } = window.vzFlags || {};
  if (isEPC === true || getSession('isEPC') === 'Y') {
    return true;
  }
  return false;
};

export const getReviewDetailsData = (str) => {
  const availablePlansId = Object.keys(str?.plans);
  if (str?.planReferenceDataList || availablePlansId?.length > 0) {
    const prodGrop = {};
    const planProd = {};
    str.planProductGroupReferenceDataList.forEach((item) => {
      prodGrop[item.groupId] = item;
    });
    str.planReferenceDataList.forEach((item) => {
      planProd[item.planId] = item;
    });
    const availablePlans = availablePlansId.reduce((acc, avPlanNo) => {
      if (planProd?.[avPlanNo] !== undefined) {
        acc[avPlanNo] = {
          planProducts: planProd[avPlanNo]?.planProducts,
          planProductGroups: planProd[avPlanNo]?.planProductGroups,
          prodGroupingDetails: [],
          planName: str?.plans?.[Number(avPlanNo)]?.planDisplayName,
        };
        planProd[avPlanNo].planProductGroups.forEach((item) => {
          acc[avPlanNo].prodGroupingDetails.push(prodGrop[item].headerText);
        });
      }
      return acc;
    }, {});

    Object.entries(availablePlans).forEach(([key, item]) => {
      const productDetailsWithSortedOrder = {};
      const productDetailsWithoutSortedOrder = {};
      if (item?.planProducts && str?.planProductReferenceDataList) {
        item.planProducts.forEach((ele, index) => {
          str.planProductReferenceDataList.forEach((productid) => {
            if (productid?.productId === ele) {
              //  added in 2 object because of ordering
              productDetailsWithSortedOrder[index] = productid;
              productDetailsWithoutSortedOrder[ele] = { ...productid, index };
            }
          });
        });
      }
      availablePlans[key].planProductDetails = productDetailsWithSortedOrder;
      availablePlans[key].planProductDetailsWithoutSortedOrder = productDetailsWithoutSortedOrder;
    });

    return availablePlans;
  }
};

export const getReviewPlanDataObject = (data) => {
  const featureTitle = []; // productName
  const featureSubHead = []; // marketingDesc
  const featureDesc = []; // groupDescription
  const featureIcon = []; // icon
  const featureSubTitle = [];
  if (data?.planProductDetails) {
    Object.values(data?.planProductDetails).forEach((item) => {
      featureTitle.push(item.description);
      featureSubHead.push(item.marketingDesc);
      featureDesc.push(item.groupDescription);
      featureIcon.push(item.icon);
      featureSubTitle.push(item?.groupName?.toUpperCase() === 'SPEED' ? item.marketingDesc : '');
    });
  }
  return {
    featureTitle,
    featureSubHead,
    featureDesc,
    featureIcon,
    featureSubTitle,
  };
};

export const getReviewDetails = (planId, featureTitle, featureSubHead, featureIcon, featureDesc) => {
  const data = featureTitle
    ? featureTitle.map((_, idx) => {
      const helperTextData = featureSubHead?.[idx] === featureDesc?.[idx] ? '' : featureDesc?.[idx];
      return (
        featureTitle[idx] !== '-NA-' &&
          featureTitle[idx] !== 'Verizon Cloud Unlimited' && {
          icon: {
            name: featureIcon?.[idx] !== '-NA-' && featureIcon?.[idx],
            ariaHidden: 'true',
          },
          title: {
            children: featureTitle[idx] !== '-NA-' && featureTitle[idx],
            primitive: 'h3',
            id: `${featureTitle[idx] !== '-NA-' && featureTitle[idx]} -${planId}`,
          },
          subtitle: {
            children: featureSubHead?.[idx] !== '-NA-' && parse(featureSubHead?.[idx] || ''),
          },
          helperText: {
            children: featureDesc?.[idx] !== '-NA-' && parse(helperTextData || ''),
          },
        }
      );
    })
    : [];
  return data;
};

export const getPriceGuarantee = (featureTitle, isLegacyPlan = false) => {
  let value;
  if (featureTitle && featureTitle.length > 0) {
    featureTitle.forEach((feature) => {
      if (isLegacyPlan && feature?.includes('Price Guarantee')) {
        const itemValue = feature?.match(/\d+/)?.[0];
        if (feature?.includes('Price Guarantee')) {
          value = itemValue;
        }
      } else if (isLegacyPlan === false && (feature.includes('-Years Price Guarantee') || feature.includes('-Year Price Guarantee'))) {
        value = feature.split('-')?.[0];
      }
    });
  }
  return value;
};

export const getComparePlansPrice = (moversPlansState, planId, entirePlansData, isLegacyPlan = false) => {
  let details = {};
  let getFeatureDetails = {};
  let getDetails = {};

  if (checkIsEPCFlow() && checkIsMoversPlansPage() === false) {
    details = getReviewDetailsData(moversPlansState);
    getDetails = getReviewPlanDataObject(details[planId]);
    getFeatureDetails = getPriceGuarantee(getDetails?.featureTitle, isLegacyPlan);
  } else {
    const willowTitle = entirePlansData?.willowFeatures?.[planId]?.featureTitle || getPlanReferenceData()?.willowFeatures?.[planId]?.featureTitle;
    getFeatureDetails = getPriceGuarantee(willowTitle, isLegacyPlan);
  }
  return getFeatureDetails;
};

export const CheckIsDiscountEnabled = () => {
  const { isDiscountEnabled } = window.vzFlags || {};
  if (isDiscountEnabled === true || getSession('isDiscountEnabled') === 'Y') {
    return true;
  }
  return false;
};

export const getMoversColorTheme = () => {
  let theme;

  if (window.vzFlags?.colorTheme !== '') {
    theme = window.vzFlags?.colorTheme;
  } else {
    theme = '';
  }

  return theme;
};

export const checkIsMoversPlansPage = () => {
  const { isSalesApproach } = window.vzFlags || {};
  if (isMoversFlow() && isMoversPhase2() && (isSalesApproach === true || getSession('isSalesApproach') === 'Y')) {
    return true;
  }
  return false;
};

export const getChoiceOlayArray = (arr, type, descArr = []) => {
  switch (type) {
    case 'ttl':
      return arr?.map((item, index) =>
        arr[index] !== '-NA-' && {
          primitive: 'h2',
          children: arr[index],
        }
      );
    case 'subhead':
      return arr?.map((item, index) => ({
        title: {
          children: arr[index] !== '-NA-' && arr[index],
          primitive: 'h3',
        },
        body: {
          children: descArr[index] !== '-NA-' && descArr[index],
        },
      }));
    case 'ftr':
    case 'desc':
      return arr?.map((item, index) => ({
        children: arr[index] !== '-NA-' && arr[index],
      }));
    case 'img':
      return arr?.map((item, index) => ({
        src: arr[index] !== '-NA-' && arr[index],
        alt: arr[index] && arr[index] !== '-NA-' && 'common product image',
      }));
    default:
      return [];
  }
};

/**
 * Shared utility function to check if a plan item should be filtered based on VHI Lite feature flags
 * @param {Object} planItem - The plan item to check
 * @param {string} planItem.name - The name of the plan item
 * @returns {boolean} - True if the item should be included, false if it should be filtered out
 */
export const shouldIncludePlanItem = (planItem) => {
  if (planItem?.name?.toLowerCase() === 'free professional setup') {
    if ((isVHILiteAllplansIncludeFFlag() && isVHILiteFlow()) || (istgwAllPlansIncludeFFlag() && getSession('isTGW') === 'true')) {
      return false;
    }
  }
  return true;
};

/**
 * Shared utility function to create a standardized plan list item object
 * @param {Object} planInfo - The plan information object
 * @param {string} planInfo.name - The name of the plan item
 * @param {string} planInfo.icon - The icon name for the plan item
 * @returns {Object} - Standardized plan list item object
 */
export const createPlanListItem = (planInfo) => ({
  children: planInfo?.name,
  alignment: 'center',
  className: `thunderPlans allPlansList ${planInfo?.icon}`,
  icon: {
    size: 'large',
    name: planInfo?.icon,
    color: '#ee0000',
    ariaHidden: 'true',
  },
});
